import OfferInterface from 'interfaces/offer.interface';
import { FILTER_OPTIONS, OFFERS_FILTERS } from 'modules/product/views/components/product-offers-header/data/filter-options.data';
import { RATES_PATTERN_WORDS } from 'modules/product/views/components/product-offers/components/rates';
import { FREE_DELIVERY_PATTERN_WORDS } from 'modules/product/views/components/product-offers/components/delivery';
import DealerBadgeInterface from 'interfaces/dealer-badge.interface';

export const shouldShowOfferBadge = (item: DealerBadgeInterface, offerDescription: string, wordPattern: string[]): boolean => {
    return (!item?.range || (item?.range && wordPattern.some(word => offerDescription.includes(word))));
};

export default function getFiltersOffersCount(offers: OfferInterface[]): { [key: string]: number; } {
    const offersCount: { [key: string]: number; } = FILTER_OPTIONS.reduce((acc, item) => ({
        ...acc,
        [item.value]: 0
    }), {});

    offers.forEach(offer => {
        const isAuthorized = offer.dealer.producer?.config.badges.authorized;

        if (isAuthorized) {
            offersCount[OFFERS_FILTERS.IS_AUTHORIZED] += 1;
        }

        const isOpineoCertificate = offer.dealer.opinions?.badges.credibilityVerification;

        if (isOpineoCertificate) {
            offersCount[OFFERS_FILTERS.OPINEO_CERTIFICATE] += 1;
        }

        const isPersonalReceipt = offer.dealer.shippings?.some(item => item.service === 'Odbiór osobisty');

        if (isPersonalReceipt) {
            offersCount[OFFERS_FILTERS.PERSONAL_RECEIPT] += 1;
        }

        const isDelivery24hBadge = offer.dealer.badges.some(item => item.type === OFFERS_FILTERS.DELIVERY_24H);
        const isDelivery24h = offer.availability?.label === 'Wysyłka w 24h';

        if (!isDelivery24hBadge && isDelivery24h) {
            offersCount[OFFERS_FILTERS.DELIVERY_24H] += 1;
        }

        offer.dealer.badges.forEach(item => {
            if (Object.prototype.hasOwnProperty.call(offersCount, item.type)) {
                if (item.type === OFFERS_FILTERS.RATES) {
                    if (shouldShowOfferBadge(item, offer.description, RATES_PATTERN_WORDS)) {
                        offersCount[item.type] += 1;
                    }
                } else if (item.type === OFFERS_FILTERS.FREE_DELIVERY) {
                    if (shouldShowOfferBadge(item, offer.description, FREE_DELIVERY_PATTERN_WORDS)) {
                        offersCount[item.type] += 1;
                    }
                } else {
                    offersCount[item.type] += 1;
                }
            }
        });
    });

    return offersCount;
}
